export const blockIconsActivitiesBiotechNew = (
	<span className='material-symbols-outlined'>biotech</span>
);
